import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AccountService } from '../../features/account/account.service';
import { first, map, switchMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { AuthenticationService } from '@tc/security-oauth-legacy';

@Injectable()
export class AccountValidityGuard {
  private router = inject(Router);
  private accountService = inject(AccountService);
  private authService = inject(AuthenticationService);


  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.authService.isAuthenticated$.pipe(
      first(),
      switchMap((isAuthenticated) => {
        if (isAuthenticated) {
          return this.accountService.requiresVerificationData$.pipe(
            first(),
            map((requiresVerification) => {
              if (requiresVerification) {
                this.router.navigateByUrl('/create');
                return false;
              } else {
                return true;
              }
            })
          );
        }
        return of(true);
      })
    );
  }
}
